'use strict';

var _caligramReact = require('caligram-react');

_caligramReact.CaligramReact.config({
  // This configuration object will be passed to caligram-react.
  // See https://gitlab.com/territoires/caligram-react/blob/master/src/config.js
});


//////////////////
// WEBPACK FOOTER
// ./src/caligramReact.js
// module id = 1158
// module chunks = 0